// Profile Questions for Extended Assessment (Part 2)
// Additional demographic and lifestyle information for comprehensive metrics

// Minified for the conference: only the three lifestyle answers the metrics
// engine actually consumes (sleep_hours, exercise_frequency, social_support).
// The production onboarding also asks height, weight, gender, living and work.
const profileQuestions = [
  {
    id: 'sleep_hours',
    type: 'number',
    category: 'health',
    question: 'On average, how many hours of sleep do you get per night?',
    description: 'Sleep quality significantly impacts mental and physical health',
    unit: 'hours',
    placeholder: 'e.g., 7',
    min: 0,
    max: 24,
    step: 0.5
  },
  {
    id: 'exercise_frequency',
    type: 'single-choice',
    category: 'health',
    question: 'How often do you engage in physical exercise?',
    description: 'Physical activity is linked to better mental health outcomes',
    options: [
      { text: 'Daily', value: 'daily' },
      { text: '3-5 times per week', value: 'regular' },
      { text: '1-2 times per week', value: 'occasional' },
      { text: 'Rarely or never', value: 'rarely' }
    ]
  },
  {
    id: 'social_support',
    type: 'rating',
    category: 'lifestyle',
    question: 'How would you rate your social support network?',
    description: 'Strong social connections are vital for recovery and wellness',
    scale: {
      min: 1,
      max: 5,
      labels: { 1: 'Very poor', 2: 'Poor', 3: 'Moderate', 4: 'Good', 5: 'Excellent' }
    }
  }
];

// Helper function to get questions by category
function getProfileQuestionsByCategory(category) {
  return profileQuestions.filter(q => q.category === category);
}

// Helper function to validate profile answer
function validateProfileAnswer(questionId, answer) {
  const question = profileQuestions.find(q => q.id === questionId);
  if (!question) return { valid: false, error: 'Question not found' };

  // Optional questions can be skipped
  if (question.optional && (answer === null || answer === undefined || answer === '')) {
    return { valid: true };
  }

  // Type-specific validation
  if (question.type === 'number') {
    const num = parseFloat(answer);
    if (isNaN(num)) return { valid: false, error: 'Please enter a valid number' };
    if (question.min !== undefined && num < question.min) {
      return { valid: false, error: `Value must be at least ${question.min}` };
    }
    if (question.max !== undefined && num > question.max) {
      return { valid: false, error: `Value must not exceed ${question.max}` };
    }
  }

  if (question.type === 'single-choice' && !answer) {
    return { valid: false, error: 'Please select an option' };
  }

  if (question.type === 'rating') {
    const rating = parseInt(answer);
    if (isNaN(rating) || rating < question.scale.min || rating > question.scale.max) {
      return { valid: false, error: `Please select a rating between ${question.scale.min} and ${question.scale.max}` };
    }
  }

  return { valid: true };
}

// ES6 Exports
export { profileQuestions, getProfileQuestionsByCategory, validateProfileAnswer };
